export function cacheKey(key: string) {
  return `next:${key}`
}

export function refreshLockCacheKey(key: string) {
  return cacheKey(`token-refresh-lock:${key}`)
}
